import EfModal from '@/components/UI/Modal';
import { createEFPic } from '@/utils/useEFPic';
import { useGlobal } from '@/utils/useGlobal';
import styles from './index.module.scss';
import { useRouter } from 'next/router';

const { EFPic } = createEFPic('/media/river2/h5/');

interface checkRuntimeModalProps {
    open: boolean;
    setOpen: (state: boolean) => void;
    container?: any;
}

export default function R({ open, setOpen }: checkRuntimeModalProps) {
    const { useLang, isMobile } = useGlobal();
    const { locale = 'us' } = useRouter();
    const { t } = useLang('productriver2.river2.details');

    const data = [
        {
            device: 'Phone (11Wh)',
            river2: '19 charges',
            river2Max: '38 charges',
            river2Pro: '57 charges',
            key: '1',
        },
        {
            device: 'Laptop (60W)',
            river2: '3.4 charges',
            river2Max: '6.8 charges',
            river2Pro: '10.2 charges',
            key: '2',
        },
        {
            device: 'Light (10W DC)',
            river2: '20 hrs',
            river2Max: '40 hrs',
            river2Pro: '60 hrs',
            key: '3',
        },
        {
            device: 'Portable Wifi (10W)',
            river2: '20 hrs',
            river2Max: '40 hrs',
            river2Pro: '60 hrs',
            key: '4',
        },
        {
            device: 'Fan (40W)',
            river2: '4.6 hrs',
            river2Max: '9.2 hrs',
            river2Pro: '13.8 hrs',
            key: '5',
        },
        {
            device: 'Mini Fridge（50W)',
            river2: '4.6 hrs',
            river2Max: '9.2 hrs',
            river2Pro: '13.8 hrs',
            key: '6',
        },
        {
            device: 'Air Pump (120W)',
            river2: '1.7 hr',
            river2Max: '3.4 hr',
            river2Pro: '6.1 hr',
            key: '7',
        },
        {
            device: 'Blender (500W)',
            river2: '0.68 hrs',
            river2Max: '0.8 hrs',
            river2Pro: '1.2 hrs',
            key: '8',
        },
        {
            device: 'Coffee maker (1000W)',
            river2: '—',
            river2Max: '0.8 hr',
            river2Pro: '0.77 hr',
        },
        {
            device: 'Space heater (1500W)',
            river2: '—',
            river2Max: '—',
            river2Pro: '0.77 hr',
            key: '9',
        },
    ];

    return (
        <EfModal
            open={open}
            visible={open}
            width={isMobile ? '100%' : 1200}
            className={styles.CheckRuntimeModalH5}
            onCancel={() => setOpen(false)}
            wrapClassName="ef-river2R-mobile-modal"
        >
            <div className="content">
                <div className="table-header">
                    <div className="column river2-column">
                        <div className="pic-box">
                            {locale === 'ph' ? (
                                <img src="https://websiteoss.ecoflow.com/upload/image/1751081751280/1.png" className="header-pic river2" />
                            ) : (
                                <EFPic name={['R-river2-runtime.png', 'R-river2-runtime.png']} className="header-pic river2"></EFPic>
                            )}
                        </div>
                        <div className="title">{t('R_p1') || 'RIVER 2'}</div>
                        <div className="desc">{t('R_p1_text') || `256Wh Capacity | 300W Output`}</div>
                    </div>
                    <div className="column">
                        <div className="pic-box">
                            {locale === 'ph' ? (
                                <img src="https://websiteoss.ecoflow.com/upload/image/1751081751483/2.png" className="header-pic river2-max" />
                            ) : (
                                <EFPic name={['R-river2-max-runtime.png', 'R-river2-max-runtime.png']} className="header-pic river2-max"></EFPic>
                            )}
                        </div>
                        <div className="title">{t('R_p2') || 'RIVER 2 Max'}</div>
                        <div className="desc">{t('R_p2_text') || '512Wh Capacity | 500W Output'}</div>
                    </div>
                    <div className="column">
                        <div className="pic-box">
                            {locale === 'ph' ? (
                                <img src="https://websiteoss.ecoflow.com/upload/image/1751081751673/3.png" className="header-pic river2-pro" />
                            ) : (
                                <EFPic name={['R-river2-pro-runtime.png', 'R-river2-pro-runtime.png']} className="header-pic river2-pro"></EFPic>
                            )}
                        </div>
                        <div className="title">{t('R_p3') || 'RIVER 2 Pro'}</div>
                        <div className="desc">{t('R_p3_text') || '768Wh Capacity | 800W Output'}</div>
                    </div>
                </div>
                <ul className="table-body">
                    {data.map((item, index: number) => (
                        <li className={`row ${index === data.length - 1 ? 'last' : ''}`} key={index}>
                            <div className="row-title">{t(`R_row${index + 1}_col1`) || item.device}</div>
                            <div className="row-content">
                                <span className="row-item">{t(`R_row${index + 1}_col2`) || item.river2}</span>
                                <span className="row-item">{t(`R_row${index + 1}_col3`) || item.river2Max}</span>
                                <span className="row-item">{t(`R_row${index + 1}_col4`) || item.river2Pro}</span>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        </EfModal>
    );
}
